import apiSetting from '../apiSetting';

const API_URL = process.env.REACT_APP_API_URL || window.APP_CONFIG.REACT_APP_API_URL;

/**
 * 取得日誌日期列表
 * @returns {Promise} 日誌日期列表
 */
export const getLogDates = async () => {
    const response = await apiSetting({
        method: 'GET',
        url: `${API_URL}/logs/getLogDates`,
    });
    return response;
};

/**
 * 取得特定日期的日誌內容（支援分頁和過濾）
 * @param {string} date - 日期 (YYYY-MM-DD 格式)
 * @param {string} type - 日誌類型 (all, error, info, warning)
 * @param {number} page - 頁碼
 * @param {number} pageSize - 每頁筆數
 * @param {string} startTime - 開始時間 (HH:MM:SS)
 * @param {string} endTime - 結束時間 (HH:MM:SS)
 * @param {string} keyword - 搜尋關鍵字
 * @returns {Promise} 日誌內容
 */
export const getLogs = async (date, type = 'all', page = 1, pageSize = 100, startTime = '', endTime = '', keyword = '', sortOrder = 'desc', userID = '') => {
    const params = new URLSearchParams({
        date,
        type,
        page: page.toString(),
        pageSize: pageSize.toString(),
        sortOrder,
        userID
    });
    
    if (startTime) params.append('startTime', startTime);
    if (endTime) params.append('endTime', endTime);
    if (keyword) params.append('keyword', keyword);

    const response = await apiSetting({
        method: 'GET',
        url: `${API_URL}/logs/getLogs?${params.toString()}`,
    });
    return response;
};
